import styled from 'styled-components';

export const ShowMore = styled.span`
  padding: 3px 12px;
  border-radius: ${({ theme }) => theme.borderRadius};
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.lightGrey};
    color: ${({ theme }) => theme.mainColor};
  }
`;
